Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../styles");
var useStyles = exports.useStyles = function useStyles() {
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    grid = _STYLES$useStyles.grid,
    fontBold = _STYLES$useStyles.fontBold,
    fontSize = _STYLES$useStyles.fontSize,
    lineHeight = _STYLES$useStyles.lineHeight,
    COLORS = _STYLES$useStyles.COLORS,
    colors = _STYLES$useStyles.colors,
    spacing = _STYLES$useStyles.spacing,
    focused = _STYLES$useStyles.focused;
  var _height = 3.75;
  var container = {
    width: '100%',
    alignItems: 'center'
  };
  var share = {
    width: '100%',
    height: (0, _styles.getREM)(_height),
    borderRadius: (0, _styles.getREM)(_height / 2),
    borderWidth: (0, _styles.getREM)(0.125),
    borderColor: colors.brand,
    borderStyle: 'solid',
    paddingTop: spacing.xs,
    paddingBottom: spacing.xs,
    paddingLeft: spacing.l,
    paddingRight: 0,
    maxWidth: grid.maxInputWidth,
    backgroundColor: COLORS.white,
    flexDirection: 'row',
    gap: spacing.normal,
    justifyContent: 'space-between',
    alignItems: 'center'
  };
  var share_focused = Object.assign({}, focused);
  var share_pressed = {
    opacity: 0.6
  };
  var text = Object.assign({}, fontBold, {
    fontSize: fontSize.m,
    lineHeight: lineHeight.m,
    color: COLORS.aubergine,
    textAlign: 'left',
    overflow: 'hidden',
    flexShrink: 1
  });
  var buttonText = {
    height: (0, _styles.getREM)(_height),
    borderRadius: (0, _styles.getREM)(_height / 2),
    lineHeight: (0, _styles.getREM)(_height),
    paddingTop: 0,
    paddingBottom: 0,
    minWidth: (0, _styles.getREM)(5.9375)
  };
  var styles = _reactNative.StyleSheet.create({
    container: container,
    share: share,
    share_focused: share_focused,
    share_pressed: share_pressed,
    text: text,
    buttonText: buttonText
  });
  return {
    styles: styles
  };
};